export default __webpack_public_path__ + "static/image3-292160ea3439899034dc1ae07696e648.jpeg";